import "../Common/css/styles.css";
import { ReactElement } from "react";

interface Props {
  children: ReactElement;
}

export default function AuthLogin({ children }: Readonly<Props>) {
  return (
    <div className="main-outer-container">
      <div className="overlay"></div>
      <div className="login-container middle">
        <div className="login-content-container middle">
          <div className="login-outer">{children}
          </div>
        </div>
      </div>
    </div>
  );
}
